//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { DeviceMeterModel, FieldNameValueModel, FormValuesModel, LocationFormValuesModel } from '../api/api.models'

import { CommonHelper } from '../../helpers/common-helper'
import { DataProvider } from '../../helpers/data-provider'
import { LocalizationHelper } from '../../helpers/localization-helper'

import { Enums } from '../../models/common/enums'
import { OpData } from '../../models/core/op-data'
import { OpDevice } from '../../models/core/op-device'
import { OpLocation } from '../../models/core/op-location'
import { OpMeter } from '../../models/core/op-meter'
import { OpValidateInfo } from '../../models/custom/op-validate-info'

import { IOpObject } from '../../models/util/interfaces'

/**
 * OBSOLETE - Use LocationService
 * */
export class LocationHelper {

    // Consts

    private static get LOG_STRING(): string { return '[SIMAX.Location.LocationHelper] - %s' }
 
    // Consts End


    // Methods 

    public static validateLocations(dataProvider: DataProvider, locations: OpLocation[]): JQueryPromise<OpValidateInfo[]> {
        return dataProvider.Location
            .validateLocation(locations)
            .then((validateInfoList: OpValidateInfo[]) => {
                if (validateInfoList == null || validateInfoList.length === 0) {
                    return $.Deferred<OpValidateInfo[]>().reject("No response or response empty.")
                }

                return validateInfoList;
            })
            .fail((error: any) => {
                console.warn(LocationHelper.LOG_STRING, "Unable to validate location.", error)

                CommonHelper.openInfoPopup(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator), 'error', 5000)

                return $.Deferred<OpValidateInfo[]>().reject()
            })
        
    }

    // Methods End


    // TODO Medoty do wywalenia po przerobieniu modułu lokalizacji

    public static locationFromLocationFormValuesModel(locationModel: LocationFormValuesModel): OpLocation {
        const location: OpLocation = LocationHelper.locationFromFormValuesModel(locationModel)

        location.currentDevices.push(...LocationHelper.getStateList(OpDevice, locationModel.devices, locationModel.addedDevices, locationModel.removedDevices))
        location.currentMeters.push(...LocationHelper.getStateList(OpMeter, locationModel.meters, locationModel.addedMeters, locationModel.removedMeters))
        location.parentGroups.push(...LocationHelper.getStateList(OpLocation, locationModel.groups, locationModel.addedGroups, locationModel.removedGroups))

        // Removing

        if (locationModel.locationToAssign != null) {
            if (locationModel.removeWithDevices == null) {
                location.currentDevices
                    .filter((device: OpDevice) => device.opState === Enums.OpChangeState.Delete)
                    .forEach((device: OpDevice) => {
                        const location: OpLocation = new OpLocation(null)

                        location.idObject = locationModel.locationToAssign
                        location.opState = Enums.OpChangeState.Loaded

                        device.currentLocations.push(location)
                })

                if (locationModel.removeWithMeters === true) {
                    location.currentMeters
                        .filter((meter: OpMeter) => meter.opState === Enums.OpChangeState.Delete)
                        .forEach((meter: OpMeter) => {
                            const location: OpLocation = new OpLocation(null)

                            location.idObject = locationModel.locationToAssign
                            location.opState = Enums.OpChangeState.Loaded

                            meter.opState = Enums.OpChangeState.Loaded

                            meter.currentLocations.push(location)
                        })
                }
            }

            if (locationModel.removeWithMeters == null) {
                location.currentMeters
                    .filter((meter: OpMeter) => meter.opState === Enums.OpChangeState.Delete)
                    .forEach((meter: OpMeter) => {
                        const location: OpLocation = new OpLocation(null)

                        location.idObject = locationModel.locationToAssign
                        location.opState = Enums.OpChangeState.Loaded

                        meter.currentLocations.push(location)
                    })

                if (locationModel.removeWithDevices === true) {
                    location.currentDevices
                        .filter((device: OpDevice) => device.opState === Enums.OpChangeState.Delete)
                        .forEach((device: OpDevice) => {
                            const location: OpLocation = new OpLocation(null)

                            location.idObject = locationModel.locationToAssign
                            location.opState = Enums.OpChangeState.Loaded

                            device.opState = Enums.OpChangeState.Loaded

                            device.currentLocations.push(location)
                        })
                }
            }
        }

        // Removing End


        // Adding

        // Adding new device and meter
        if (locationModel.deviceWithMeter && locationModel.deviceWithMeter.length > 0) {
            locationModel.deviceWithMeter.forEach((model: DeviceMeterModel) => {
                const existingDevice: OpDevice = _.find(location.currentDevices, (device: OpDevice) => device.idObject === model.serialNbr)

                if (existingDevice != null) {
                    const meter: OpMeter = new OpMeter(null)

                    meter.idObject = model.idMeter
                    meter.opState = Enums.OpChangeState.Loaded

                    existingDevice.currentMeters.push(meter)
                    existingDevice.opState = Enums.OpChangeState.New

                    const device: OpDevice = new OpDevice(null)

                    device.idObject = existingDevice.idObject
                    device.opState = Enums.OpChangeState.New

                    meter.currentDevices.push(device)
                    location.currentMeters.push(meter)
                }
                else {
                    const existingMeter: OpMeter = _.find(location.currentMeters, (meter: OpMeter) => meter.idObject === model.idMeter)

                    if (existingMeter != null) {
                        const device: OpDevice = new OpDevice(null)

                        device.idObject = model.serialNbr
                        device.opState = Enums.OpChangeState.Loaded

                        existingMeter.currentDevices.push(device)
                        existingMeter.opState = Enums.OpChangeState.New

                        const meter: OpMeter = new OpMeter(null)

                        meter.idObject = model.idMeter
                        meter.opState = Enums.OpChangeState.New

                        device.currentMeters.push(meter)
                        location.currentDevices.push(device)
                    }
                }
            })
        }

        // Adding a meter to an existing device or a device to an existing meter
        if (locationModel.deviceMeter && locationModel.deviceMeter.length > 0) {
            locationModel.deviceMeter.forEach((model: DeviceMeterModel) => {
                const existingDevice: OpDevice = _.find(location.currentDevices, (device: OpDevice) => device.idObject === model.serialNbr)

                if (existingDevice != null) {
                    let meter: OpMeter = _.find(existingDevice.currentMeters, (meter: OpMeter) => meter.idObject === model.idMeter)
                    let meterExists: boolean = true

                    if (meter == null) {
                        meter = new OpMeter(null)
                        meter.idObject = model.idMeter

                        meterExists = false
                    }

                    meter.opState = Enums.OpChangeState.New

                    if (!meterExists) {
                        existingDevice.currentMeters.push(meter)
                    }

                    existingDevice.opState = Enums.OpChangeState.New

                    const device: OpDevice = new OpDevice(null)

                    device.idObject = existingDevice.idObject
                    device.opState = Enums.OpChangeState.New

                    if (!meterExists) {
                        meter.currentDevices.push(device)
                        location.currentMeters.push(meter)
                    }
                }
                else {
                    const existingMeter: OpMeter = _.find(location.currentMeters, (meter: OpMeter) => meter.idObject === model.idMeter)

                    if (existingMeter != null) {
                        let device: OpDevice = _.find(existingMeter.currentDevices, (device: OpDevice) => device.idObject === model.serialNbr)
                        let deviceExists = true

                        if (device == null) {
                            device = new OpDevice(null)
                            device.idObject = model.serialNbr

                            deviceExists = false
                        }

                        device.opState = Enums.OpChangeState.New

                        if (!deviceExists) {
                            existingMeter.currentDevices.push(device)
                        }

                        existingMeter.opState = Enums.OpChangeState.New

                        const meter: OpMeter = new OpMeter(null)

                        meter.idObject = existingMeter.idObject
                        meter.opState = Enums.OpChangeState.New

                        if (!deviceExists) {
                            device.currentMeters.push(meter)
                            location.currentDevices.push(device)
                        }
                    }
                }
            })
        }

        // Adding End


        return location
    }

    public static locationFromFormValuesModel(model: FormValuesModel): OpLocation {
        const location: OpLocation = new OpLocation(null)

        location.idObject = model.id || 0

        if (model.fields != null) {
            const locationData: OpData[] = model.fields.map((field: FieldNameValueModel) => {
                const data: OpData = new OpData(null)

                data.idData = field.id
                data.idDataType = field.idDataType
                data.opState = field.state
                data.indexNbr = field.index
                data.value = field.value

                return data
            })
            location.dataList.push(...locationData)
        }

        if (model.id > 0) {
            location.opState = Enums.OpChangeState.Modified
        }

        return location
    }

    public static validateLocationsChunked<TModel>(
        dataProvider: DataProvider,
        formModels: TModel[],
        modelMapFunction: (model: TModel) => OpLocation
    ): JQueryPromise<OpValidateInfo[]> {

        // TODO ConfigHelper - Enums był zablokowany :(
        const pageSize: number = window['config'] && window['config'].LOCATION_VALIDATION_PAGE_SIZE ? window['config'].LOCATION_VALIDATION_PAGE_SIZE : 100 
        const deferred: JQueryDeferred<OpValidateInfo[]> = $.Deferred<OpValidateInfo[]>()
        const currentValidateInfo: OpValidateInfo[] = []

        const innerLoop = (iteration: number) => {
            const start: number = iteration * pageSize
            const end: number = start + pageSize
            const locations: OpLocation[] = formModels
                .slice(start, end)
                .map(modelMapFunction)

            dataProvider.Location
                .validateLocation(locations)
                .then((validateInfo: OpValidateInfo[]) => {
                    if (validateInfo != null && validateInfo.length > 0) {
                        currentValidateInfo.push(...validateInfo)

                        if (formModels.length > end) {
                            innerLoop(++iteration)
                        }
                        else {
                            deferred.resolve(currentValidateInfo)
                        }
                    }
                    else {
                        deferred.reject("No response or response empty.")
                    }
                })
                .fail((error: any) => {
                    deferred.reject(error)
                })
        }

        innerLoop(0)

        return deferred
            .fail((error) => {
                console.warn(LocationHelper.LOG_STRING, "Unable to validate chunked locations.", error)

                return $.Deferred<OpValidateInfo[]>().reject()
            })
            .promise()
    }

    private static getStateList<T extends IOpObject>(ctor: new (opObj: any) => T, loadedIds: number[], newIds: number[], deletedIds: number[]): T[] {
        const objects: T[] = []

        if (loadedIds && loadedIds.length > 0) {
            const loadedObjects: T[] = loadedIds.map((id: number) => {
                const object: T = new ctor(null)

                object.idObject = id
                object.opState = Enums.OpChangeState.Loaded

                return object
            })

            objects.push(...loadedObjects)
        }

        if (newIds && newIds.length > 0) {
            const newObjects: T[] = newIds.map((id: number) => {
                const object: T = new ctor(null)

                object.idObject = id
                object.opState = Enums.OpChangeState.New

                return object
            })

            objects.push(...newObjects)
        }

        if (deletedIds && deletedIds.length > 0) {
            const deletedObjects: T[] = deletedIds.map((id: number) => {
                const object: T = new ctor(null)

                object.idObject = id
                object.opState = Enums.OpChangeState.Delete

                return object
            })

            objects.push(...deletedObjects)
        }

        return objects
    }

    // Metody End
}